module.exports = {
	"id": "NA",
	"name": "Namibia",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": 0.002567,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.02567,
			"12": 0.002567,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": 0.002567,
			"24": null,
			"25": 0.005134,
			"26": 0.007701,
			"27": 0.002567,
			"28": null,
			"29": 0.005134,
			"30": null,
			"31": 0.017969,
			"32": 0.012835,
			"33": 0.007701,
			"34": 0.010268,
			"35": 0.005134,
			"36": 0.023103,
			"37": 0.007701,
			"38": 0.007701,
			"39": 0.012835,
			"40": 0.038505,
			"41": 0.005134,
			"42": 0.007701,
			"43": 0.184824,
			"44": 0.107814,
			"45": 0.118082,
			"46": 0.015402,
			"47": 0.059041,
			"48": 0.028237,
			"49": 0.338844,
			"50": 0.092412,
			"51": 0.238731,
			"52": 0.254133,
			"53": 7.898659,
			"54": 2.015095,
			"55": 0.048773,
			"56": 0.010268,
			"57": null
		},
		"firefox": {
			"2": 0.005134,
			"3": 0.010268,
			"4": 0.005134,
			"5": 0.002567,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": 0.002567,
			"11": 0.012835,
			"12": 0.005134,
			"13": 0.005134,
			"14": 0.010268,
			"15": 0.010268,
			"16": 0.002567,
			"17": null,
			"18": 0.005134,
			"19": null,
			"20": 0.005134,
			"21": 0.002567,
			"22": 0.005134,
			"23": null,
			"24": 0.002567,
			"25": null,
			"26": null,
			"27": null,
			"28": 0.002567,
			"29": 0.005134,
			"30": 0.007701,
			"31": 0.05134,
			"32": 0.012835,
			"33": 0.007701,
			"34": 0.005134,
			"35": 0.043639,
			"36": 0.007701,
			"37": 0.012835,
			"38": 0.015402,
			"39": 0.02567,
			"40": 0.012835,
			"41": 0.038505,
			"42": 0.010268,
			"43": 0.094979,
			"44": 0.048773,
			"45": 0.043639,
			"46": 0.035938,
			"47": 0.35938,
			"48": 0.254133,
			"49": 2.633742,
			"50": 0.207927,
			"51": 0.007701,
			"52": null,
			"3.5": null,
			"3.6": 0.007701
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": 0.005134,
			"35": 0.005134,
			"36": 0.015402,
			"37": 0.164288,
			"38": 0.005134,
			"39": 0.030804,
			"40": 0.575008,
			"41": 0.087278,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": 0.005134,
			"12.1": 0.05134
		},
		"safari": {
			"0": null,
			"4": 0.012835,
			"5": 0.010268,
			"6": 0.005134,
			"7": 0.007701,
			"8": 0.05134,
			"9": 0.094979,
			"10": 0.313174,
			"3.1": null,
			"3.2": null,
			"5.1": 0.02567,
			"6.1": 0.005134,
			"7.1": 0.012835,
			"9.1": 0.300339
		},
		"ios_saf": {
			"8": 0,
			"10": 1.35667413072,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0365607979808,
			"8.1-8.4": 0.0675445250833,
			"9.0-9.2": 0.0322230761865,
			"9.3": 0.491608470025
		},
		"android": {
			"3": 0,
			"4": 0.0809371111111,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.0101171388889,
			"4.1": 0.291951722222,
			"4.2-4.3": 0.729879305556,
			"4.4": 1.67366383333,
			"4.4.3-4.4.4": 1.68811688889
		},
		"ie": {
			"6": 0.00522407017544,
			"7": 0.00522407017544,
			"8": 0.420537649123,
			"9": 0.297772,
			"10": 0.323892350877,
			"11": 3.11615785965,
			"5.5": null
		},
		"op_mob": {
			"0": 3.29140037513,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.0914277881981
		},
		"edge": {
			"12": 0.290071,
			"13": 0.639183,
			"14": 0.5134
		},
		"ie_mob": {
			"10": 0.234505915493,
			"11": 0.954774084507
		},
		"bb": {
			"7": 0.126361,
			"10": null
		},
		"samsung": {
			"0": 4.809151
		},
		"and_uc": {
			"0": 2.67588
		},
		"op_mini": {
			"0": 44.3444648367
		},
		"and_chr": {
			"0": 12.020294
		},
		"and_ff": {
			"0": 0.007433
		}
	},
	"total": 98.076897
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/NA.json
 ** module id = 604
 ** module chunks = 0
 **/